<script setup lang="ts">
import PageContainer from "~/components/ui/PageContainer.vue";

const downloads = [
  {
    title: "English-11 Textbook PDF",
    detail: "Primary reading source ke liye chapter-wise textbook PDF ya official board book ko yahan target kiya jata hai.",
    use: "Best for exact chapter order, poem/prose classification aur textbook exercise wording verify karne ke liye.",
  },
  {
    title: "Grammar & Composition PDF",
    detail: "Grammar paper preparation ke liye composition rules, pair of words, punctuation aur writing formats.",
    use: "Best for formal writing aur objective grammar revision.",
  },
  {
    title: "ALP / Smart Syllabus",
    detail: "Current exam focus aur exclusion awareness ke liye smart syllabus block.",
    use: "Best for board prep ko relevant units tak limit karne ke liye.",
  },
  {
    title: "Model Paper / Paper Pattern",
    detail: "Question distribution aur board paper structure ko samajhne ke liye.",
    use: "Best for yeh dekhne ke liye ke literature, grammar aur writing me weightage kis tarah aata hai.",
  },
  {
    title: "Notes PDF",
    detail: "Condensed revision notes aur printable summaries ke liye reserved section.",
    use: "Best for last-day revision aur short recall practice.",
  },
];

const resourceTips = [
  "Textbook ko primary source rakho jab chapter title ya exact exercise wording verify karni ho.",
  "Notes PDF ko textbook replacement na samjho; use revision aid ke tor par use karo.",
  "Model paper aur smart syllabus ko sath dekhne se targeted prep easy hoti hai.",
];

const suggestedOrder = [
  "Textbook PDF se chapter map aur actual reading verify karo.",
  "Notes PDF se short revision aur recall build karo.",
  "Grammar & Composition PDF se writing aur objective prep complete karo.",
  "Model Paper / Paper Pattern se final paper practice karo.",
];

const missingVsAvailable = [
  { label: "Best for exact wording", value: "Textbook PDF" },
  { label: "Best for quick revision", value: "Notes PDF" },
  { label: "Best for writing practice", value: "Grammar & Composition PDF" },
  { label: "Best for exam strategy", value: "Model Paper / Smart Syllabus" },
];

const faqs = [
  {
    question: "Which resource should I use for exact chapter wording?",
    answer: "Exact chapter order aur exercise wording verify karne ke liye textbook PDF sab se strong source hai.",
  },
  {
    question: "What is the best order for using these downloads?",
    answer: "Best order textbook, phir notes, phir grammar/composition, aur akhir me model paper ya smart syllabus hai.",
  },
  {
    question: "Can notes PDF replace the textbook?",
    answer: "Nahi. Notes PDF quick revision ke liye useful hai, lekin textbook ka replacement nahi hai.",
  },
];

usePageSeo({
  title: "11th Class English PDF Downloads | Textbook, Notes, Grammar, Model Paper",
  description: "11th class English textbook PDF, notes PDF, grammar/composition PDF, smart syllabus aur model paper resources ka organized hub.",
  keywords: "11th class english pdf, class 11 english textbook pdf, 1st year english notes pdf, grammar composition pdf, english model paper",
  schemaType: "CollectionPage",
  schemaProperties: {
    mainEntity: {
      "@type": "ItemList",
      itemListElement: downloads.map((item, index) => ({
        "@type": "ListItem",
        position: index + 1,
        name: item.title,
      })),
    },
  },
  faqs,
  breadcrumbs: [
    { name: "Home", item: "/" },
    { name: "11th English", item: "/11th/english/" },
    { name: "Downloads", item: "/11th/english/downloads/" },
  ],
});
</script>

<template>
  <PageContainer>
    <EnglishHero
      headline="Resource Hub"
      title="11th Class English Downloads"
      description="Yeh page English prep ke core resource types ko organize karta hai. Is ka purpose yeh clear karna hai ke kis type ka PDF kis kaam ke liye useful hota hai."
    />

    <EnglishSection title="Download Types" description="Each card explains what that resource type is best used for.">
      <EnglishGrid>
        <EnglishCard
          v-for="item in downloads"
          :key="item.title"
          :title="item.title"
          :description="`${item.detail} Best use: ${item.use}`"
        />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Resource Tips" description="Use these rules when deciding which PDF or download to open first.">
      <EnglishGrid>
        <EnglishCard v-for="item in resourceTips" :key="item" title="Tip" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Suggested Study Order" description="This order keeps the resource flow practical and exam-focused.">
      <EnglishGrid>
        <EnglishCard v-for="item in suggestedOrder" :key="item" title="Step" :description="item" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="Best Use by Resource Type" description="Use this as a quick selector when you are deciding what to open.">
      <EnglishGrid>
        <EnglishCard v-for="item in missingVsAvailable" :key="item.label" :title="item.label" :description="item.value" />
      </EnglishGrid>
    </EnglishSection>

    <EnglishSection title="FAQs" description="Short answers before you choose a resource path.">
      <EnglishGrid>
        <EnglishCard v-for="item in faqs" :key="item.question" :title="item.question" :description="item.answer" />
      </EnglishGrid>
    </EnglishSection>
  </PageContainer>
</template>
